import React from "react";

// import { Link } from "react-router-dom";
import { ConnectionProviders } from "../../../components/ConnectionProviders/ConnectionProviders";
// import {
//   IOrganization,
//   useOrganizationContext,
// } from "../../../contexts/organizations/organizationsContext";
// import { IRole, useAuth } from "../../../pages/auth";

interface IProps {
  userData: any;
}

export const Overview: React.FC<IProps> = ({ userData }) => {
  return (
    <div className="card mb-5 mb-xl-10">
      <div className="card-header border-0 cursor-pointer">
        <div className="card-title m-0">
          <h3 className="fw-bolder m-0">Profile details</h3>
        </div>
        {/*
          <Link
            to="/account/settings"
            className="btn btn-primary align-self-center text-white"
          >
            Edit
          </Link> */}
      </div>
      <hr className="mx-9 my-0" />
      <div className="card-body p-9">
        <div className="row mb-7">
          <label className="col-lg-2 fw-bold text-muted">Full name:</label>
          <div className="col-lg-10">
            <span className="fw-bolder fs-6">
              {userData?.firstName} {userData?.lastName}
            </span>
          </div>
        </div>

        <div className="row mb-7">
          <label className="col-lg-2 fw-bold text-muted">Email:</label>
          <div className="col-lg-10 fv-row">
            <span className="fw-bold fs-6">{userData?.email}</span>
          </div>
        </div>
        {/* <div className="row mb-7">
            <label className="col-lg-4 fw-bold text-muted">Role</label>
            <div className="col-lg-8">
              <span className="fw-bold fs-6">{currentRoles}</span>
            </div>
          </div> 
            */}
        {userData && (
          <div className="">
            <p className="fw-bolder mb-0">Connected accounts</p>
            <p className="mt-2 mb-0 fw-normal">
              Use your credentials for the sites below to login to CogCache
              quickly, easily, and securely.
            </p>

            <ConnectionProviders providers={userData?.providers} />
          </div>
        )}
      </div>
    </div>
  );
};
